import { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { ADMIN_MANY_ORDERS_API_PATHS } from '../constants/orders-api-paths.constant';
import HttpClient from '../../shared/infrastructures/clients/http.client';
import { DeliveryNote } from '../types/delivery-note.type';

interface DeliveryNotesState {
  loading: boolean;
  deliveryNotes: DeliveryNote[] | null;
}

export function useGetOrdersDeliveryNotes(deliveryDate: string): DeliveryNotesState {
  const { enqueueSnackbar } = useSnackbar();

  const [result, setResult] = useState<DeliveryNotesState>({ loading: true, deliveryNotes: null });

  useEffect(() => {
    if (!deliveryDate) {
      setResult({ loading: false, deliveryNotes: null });
      return undefined;
    }

    let isCancelled = false;

    setResult({ loading: true, deliveryNotes: null });

    HttpClient.get<DeliveryNote[]>(ADMIN_MANY_ORDERS_API_PATHS.GET_ORDERS_DELIVERY_NOTES, {
      params: { deliveryDate },
    })
      .then((response) => {
        if (isCancelled) return;
        setResult({ loading: false, deliveryNotes: response });
      })
      .catch((error) => {
        if (isCancelled) return;
        const message =
          error.response?.data?.message ?? 'Une erreur est survenue lors de la récupération des bons de livraison';
        enqueueSnackbar(message, { variant: 'error' });
        setResult({ loading: false, deliveryNotes: null });
      });

    return () => {
      isCancelled = true;
    };
  }, [deliveryDate]);

  return result;
}
